import { Container, Divider, HStack, SkeletonText, Tab, TabList, TabPanel, TabPanels, Tabs, TabsProps, Text } from '@chakra-ui/react';
import AvatarPaper from 'components/ui/AvatarPaper';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { useNavigate, useParams } from 'react-router-dom';
import ContentGroupForm from '../components/ContentGroupForm';
import { CONTENT_GROUP_TYPE_NAMES } from '../components/ContentGroupsList';
import ListContentGroupCategories from '../components/ListContentGroupCategories';
import { useContentGroup } from '../hooks/useContentGroup';

interface PageEditContentGroupProps {
  defaultTabIndex?: number;
}

export default function PageEditContentGroup({
  defaultTabIndex = 0,
}: PageEditContentGroupProps) {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isFetched, data: contentGroup } = useContentGroup(id);

  const isLoaded = isFetched && !!contentGroup;

  const onTabChange: TabsProps['onChange'] = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        navigate(`/modelos-de-disparo/${id}`);
        break;
      case 1:
        navigate(`/modelos-de-disparo/${id}/categorias`);
        break;
      default:
    }
  };

  return (
    <Tabs defaultIndex={defaultTabIndex} onChange={onTabChange} variant="line">
      <HeaderBarInternal
        title="Editar Modelo de Disparo"
        backTo="/modelos-de-disparo"
        dialogProps={wrapperDialogDefaultProps}
      >
      
      { contentGroup && (
        <>
          <TabList>
            <Tab>Dados do Modelo</Tab>
            <Tab>Categorias do Modelo</Tab>
          </TabList>
          
          <HStack
            ml="auto"
            spacing="10px"
          >
            <AvatarPaper 
              bg="white.100"
              borderColor="gray.300"
              borderWidth="1px"
              color="gray.800"
            />
            
            <SkeletonText noOfLines={1} isLoaded={isLoaded}>
              <Text 
                as="span" 
                color="#0A0D14"
                fontWeight={500}
                sx={{
                  small: {
                    display: 'block'
                  }
                }}
              >
                {contentGroup?.name}
                <small>
                  {contentGroup && CONTENT_GROUP_TYPE_NAMES[contentGroup.type]}
                </small>
              </Text>
            </SkeletonText>
          </HStack>
        </>
      )}

      </HeaderBarInternal>

      <Divider />

      <Container flexDirection="column">
        <SkeletonText isLoaded={isLoaded}>
        { contentGroup && (
          <TabPanels>
            <TabPanel>
              <ContentGroupForm contentGroup={contentGroup} />
            </TabPanel>
            <TabPanel>
              <ListContentGroupCategories />
            </TabPanel>
          </TabPanels>
        )}
        </SkeletonText>
      </Container>

    </Tabs>
  )
}
